import { useMemo } from "react";
import dayjs from "../dayjs";

export function useProductDateRangeLabel(products: { date: string }[]) {
  return useMemo(() => {
    const start = dayjs(products?.[0]?.date);
    const end = dayjs(products?.[products.length - 1]?.date);
    if (!start || !end) return null;
    if (start.isSame(end, "day")) {
      return start.format("DD.MM.YYYY");
    }
    return `${start.format("DD.MM")} - ${end.format("DD.MM.YYYY")}`;
  }, [products]);
}

export function ProductDateRangeLabel(props: { products: { date: string }[] }) {
  return useProductDateRangeLabel(props.products);
}
